import { BilletGroup } from "../models";

// Utility function to calculate total billets count
export const getTotalBilletsCount = (groups: BilletGroup[] = []): number => {
  return groups.reduce((sum, group) => sum + group.BilletsCount, 0);
};
